/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../../Icon';

/**
 * @deprecated since version 20.2.0. Please use the new Glyph component. You can read more about it in the prisma-design-system storybook under iconography/glyphs.
 */
const CrossLight: any = ({ color, size = 'medium', ...props }) => {
  return (
    // @ts-expect-error TODO: Fix viewBox type in next ticket OF2-3365
    <Icon viewBox="0 0 28 28" size={size} color={color} {...props}>
      <path
        d="M5.522 5.48c.14-.141.308-.252.5-.333.194-.08.393-.128.596-.142.204-.014.403.009.596.068.193.06.36.16.5.3l6.28 6.28 6.273-6.273c.14-.14.31-.242.506-.306.197-.063.399-.086.606-.068.207.017.411.07.611.158.2.087.378.209.532.363.14.14.251.307.332.5.08.194.128.392.142.596a1.59 1.59 0 01-.074.6 1.242 1.242 0 01-.305.507l-6.273 6.273 6.269 6.269c.14.14.242.309.305.506.063.196.088.397.074.6a1.868 1.868 0 01-.143.596 1.54 1.54 0 01-.332.5c-.155.155-.33.275-.527.36a1.838 1.838 0 01-.6.147 1.491 1.491 0 01-.596-.079 1.295 1.295 0 01-.5-.31l-6.27-6.27-6.305 6.305c-.14.14-.307.24-.5.3s-.392.083-.596.069a1.866 1.866 0 01-.595-.142 1.538 1.538 0 01-.5-.332 1.726 1.726 0 01-.364-.532c-.088-.2-.14-.404-.158-.611a1.568 1.568 0 01.063-.601c.06-.193.16-.36.3-.5l6.306-6.305-6.28-6.28a1.249 1.249 0 01-.306-.495 1.518 1.518 0 01-.073-.59c.014-.204.063-.405.148-.601.084-.197.203-.373.358-.527z"
        fillRule="evenodd"
      />
    </Icon>
  );
};

export default CrossLight;

CrossLight.propTypes = {
  color: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};
